import * as types from './customerActionTypes';

const initialState = {
  customerList: [],
  customerData: null,
  isLoading: false,
  error: null,
  addCustomerData: null,
  updateCustomerData: null,
  deleteCustomerData: null,
};

export const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CUSTOMER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_CUSTOMER_SUCCESS:
      return { ...state, isLoading: false, 
        customerList: action.payload?.CustomerList || [], error: null };
    case types.GET_CUSTOMER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_CUSTOMER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_CUSTOMER_SUCCESS:
      return { ...state, isLoading: false, addCustomerData: action.payload, error: null };
    case types.ADD_CUSTOMER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_CUSTOMER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_CUSTOMER_SUCCESS:
      return { ...state, isLoading: false, updateCustomerData: action.payload, error: null };
    case types.UPDATE_CUSTOMER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_CUSTOMER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_CUSTOMER_SUCCESS:
      return { ...state, isLoading: false, deleteCustomerData: action.payload, error: null };
    case types.DELETE_CUSTOMER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
}; 